
import { Component, Vue, Watch } from "vue-property-decorator";
import { apiShopDetail, apiShopChangeSuperAdmin } from "@/api/shop";
@Component
export default class UpdateAccount extends Vue {
    /** S Data **/

    identity: number | null = null; // 当前編輯用戶的身份ID

    // 添加商城表单數據
    form: any = {
        super_admin: "", // 賬號
        super_password: "", // 密碼
        super_password_confirm: "", // 確認密碼
    };

    // 表单校验
    rules = {
        super_admin: [
            { required: true, message: "請輸入商城賬號", trigger: "blur" },
        ],
        super_password: [
            { required: true, message: "請輸入密碼", trigger: "blur" },
        ],
        super_password_confirm: [
            { required: true, message: "請再次输入密碼", trigger: "blur" },
            {
                validator: (rule: object, value: string, callback: any) => {
                    if (this.form.password) {
                        if (!value) callback(new Error("請再次输入密碼"));
                        if (value !== this.form.password)
                            callback(new Error("两次输入密碼不一致!"));
                    }
                    callback();
                },
                trigger: "blur",
            },
        ],
    };

    /** E Data **/

    /** S Methods **/
    // 點擊表单提交
    onSubmit(formName: string) {
        // 验证表单格式是否正確
        const refs = this.$refs[formName] as HTMLFormElement;
        refs.validate((valid: boolean): any => {
            if (!valid) return;
            this.handleShopEdit();
        });
    }

    // 編輯超级管理员賬號
    async handleShopEdit(): Promise<void> {
        await apiShopChangeSuperAdmin({ ...this.form, id: this.identity });
        setTimeout(() => this.$router.go(-1), 500);
    }

    // 獲取詳情
    async getShopDetailFunc(): Promise<void> {
        const res: any = await apiShopDetail({
            id: this.identity as number
        })
        this.form.super_admin = res.account // 賬號
    }

    /** E Methods **/

    /** S Life Cycle **/
    created() {
        const query: any = this.$route.query;

        // 編輯模式：初始化數據
        this.identity = +query.id;
        if (+query.id) {
            this.getShopDetailFunc();
        }
    }
    /** E Life Cycle **/
}
